import * as React from "react";

function HandIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={32} height={32} fill="none" {...props}>
      <path
        d="M26.5 10v9.75A8.232 8.232 0 0118.25 28h-1.781c-2.532 0-4.875-.938-6.657-2.719l-5.296-5.297C4.14 19.61 4 19.141 4 18.625c0-.984.797-1.875 1.875-1.875.469 0 .938.188 1.313.563L10 20.125V7c0-.797.656-1.5 1.5-1.5.797 0 1.5.703 1.5 1.5v8.25c0 .422.328.75.75.75.375 0 .75-.328.75-.75V5.5c0-.797.656-1.5 1.5-1.5.797 0 1.5.703 1.5 1.5v9.75c0 .422.328.75.703.75.422 0 .797-.328.797-.75V7c0-.797.656-1.5 1.5-1.5.797 0 1.5.703 1.5 1.5v8.25c0 .422.328.75.75.75.375 0 .75-.328.75-.75V10c0-.797.656-1.5 1.5-1.5.797 0 1.5.703 1.5 1.5z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoHandIcon = React.memo(HandIcon);
export default MemoHandIcon;
